import { render, staticRenderFns } from "./Serie.vue?vue&type=template&id=893db8d2&"
import script from "./Serie.vue?vue&type=script&lang=js&"
export * from "./Serie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports